export interface Enum {

}

export enum Status {
    Inactivo = 0,
    Activo = 1,
    Baja = 2,
    Pendiente = 3,
    Creado = 4
}

export enum CalculatedType {
    MO = 1,
    Tarifa = 2
}